// extracted by mini-css-extract-plugin
export var menuMainToggle = "main-menu-toggle-module--menuMainToggle--of4YQ";
export var menuMainActive = "main-menu-toggle-module--menuMainActive--7F0MY";